import React, { useState, useRef } from "react";
import { Grid, IconButton, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import SimpleDialog from "../../../SimpleDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Filter from "../../../Filter";
import NewExtraModal from "./NewExtraModal";
import { DataGridPro } from "@mui/x-data-grid-pro";
import * as dayjs from "dayjs";


const NoHeaderDataGrid = styled(DataGridPro)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));

const ExtraTab = ({ centerExtras, setCenterExtras, currency, admin }) => {

    const [ExtraDialogOpen, setExtraDialogOpen] = useState(false);
    const [newExtraValue, setNewExtraValue] = useState(null);

    const [filter, setFilter] = useState("");
    const [activeFilter, setActiveFilter] = useState(true);

    const searchBarHelper = "Search for a extra...";

    const updateActiveFilter = (e) => {
        setActiveFilter(e.target.checked);
    }

    const HandleFilter = (e) => {
        setFilter(e.toLowerCase());
    };

    function filterExtras(extra) {
        return extra.name.toLowerCase().includes(filter);
    }

    const centerExtrasCols = [
        { field: 'range', headerName: '', flex: 1 },
        {
            field: 'actions',
            type: 'actions',
            sortable: false,
            getActions: (params) => {
                return [
                    <>
                        {admin &&
                            <GridActionsCellItem icon={params.row.id ? <DeleteIcon /> : <></>} onClick={() => deleteExtra(params)} />
                        }
                    </>
                ]
            }
        }
    ]

    const ExtraToRange = (extra) => {
        return `(${dayjs(extra.startDate).format('DD/MM/YYYY')} - ${dayjs(extra.endDate).format('DD/MM/YYYY')})`;
    };

    const typeToString = (type) => {
        if (type > 0) {
            return "Pro Sport";
        }
        return "Optional Outing";

    }

    const getTreeDataPath = (extra, index) => {
        console.log(extra)
        const extrasWithSameName = centerExtras.filter(e => e.name === extra.name);
        const indexOfExtra = extrasWithSameName.indexOf(extra);
        return [typeToString(extra.type), extra.startDate.substring(0,4),  `${extra.name} (${indexOfExtra + 1})`];
      };

    const deleteExtra = (params) => {
        setCenterExtras(centerExtras.filter((a) => a.id != params.id));
    };

    const handleNewExtraDialogClickOpen = () => {
        let extra_tmp = {};
        extra_tmp.id = -Math.random();
        extra_tmp.name = "";
        extra_tmp.active = 1;
        extra_tmp.startDate = new Date(`${new Date().getFullYear()}-07-01`);
        extra_tmp.endDate = null;
        extra_tmp.type = 1;
        setNewExtraValue(extra_tmp);
        setExtraDialogOpen(true);
    };

    const handleNewExtraDialogClickClose = (save) => {
        setExtraDialogOpen(false);
        if (save == true) {
            if (centerExtras.filter(e => e.id == newExtraValue.id).length > 0) {
                //replace the existing center in centerExtras with newExtraValue
                setCenterExtras(centerExtras.map(e => e.id == newExtraValue.id ? newExtraValue : e))
                return;
            } else {
                setCenterExtras([...centerExtras, newExtraValue])
            }
        }
        setNewExtraValue(null);
    };
    

    const handleRowClick = (params) => {
        const extra = centerExtras.filter(extra => { return extra.id == params.row.id })[0]
        if (!extra) { return; }
        setNewExtraValue(extra);
        setExtraDialogOpen(true);
    };

    return (
        <>
            <Grid item xs={12} container sx={{ height: 350 }}>
                <div style={{ height: 350, width: '100%' }}>
                    <Grid item container >
                        <Filter
                            setSearchQuery={HandleFilter}
                            searchQuery={filter}
                            helper={searchBarHelper}
                            setActive={updateActiveFilter}
                            addDataFunction={() => handleNewExtraDialogClickOpen()}
                            HideAddButton={!admin}
                        />
                    </Grid>
                    {centerExtras ?
                        <NoHeaderDataGrid
                            treeData
                            defaultGroupingExpansionDepth={1}
                            rowGroupingColumnMode="single"
                            getTreeDataPath={getTreeDataPath}
                            rows={centerExtras.filter(filterExtras).map((Extra => {
                                Extra.range = ExtraToRange(Extra);
                                return Extra;
                            }))}

                            onRowClick={handleRowClick}
                            columns={centerExtrasCols}
                            disableSelectionOnClick
                            rowsPerPageOptions={[]} />
                        : <></>}
                </div>

                {newExtraValue ?
                    <NewExtraModal
                        show={ExtraDialogOpen}
                        setSelectedExtra={setNewExtraValue}
                        centerExtras={centerExtras}
                        selectedExtra={newExtraValue}
                        handleSubmit={() => handleNewExtraDialogClickClose(true)}
                        currency={currency}
                        onHide={() => handleNewExtraDialogClickClose(false)}>
                    </NewExtraModal> : <></>}
            </Grid>
        </>
    );
}

export default ExtraTab;